import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { GetQuery } from './Shared';

interface AllocateAssociatedJobsProps {
    scheduleId: number;
    showModal: boolean;
    hideModal(): void;
}

interface AssociatedJob {
    id: number;
    scheduleDateFormatted: string;
    type: string;
    quantityScheduled: number;
    allocatedTo: string;
    complete: boolean;
}


const AllocateAssociatedJobsData = (props: AllocateAssociatedJobsProps) => {
    const [loading, setLoading] = React.useState(true);
    const [associatedJobs, setAssociatedJobs] = React.useState<AssociatedJob[]>([]);
    
    React.useEffect(() => {
        if (props.scheduleId > 0 && props.showModal) {
            getData();
        }
    }, [props.scheduleId]);

    const getData = async () => {
        const apiUrl = "GetAssociatedJobs?ScheduleId=" + props.scheduleId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                setAssociatedJobs(result.data);
                setLoading(false);
            }
        } 
    }

    const hideModal = () => {
        props.hideModal();
    }

    const renderDetails = (
        <div className="static-modal">
            <Modal size="lg" show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Associated Jobs</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="table__margin overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th className="table__text--align">Date</th>
                                    <th className="table__text--align">Type</th>
                                    <th className="table__text--align textaligncenter">Quantity</th>
                                    <th className="table__text--align">Allocated To</th>
                                    <th className="table__text--align textaligncenter">Complete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {associatedJobs.map((job, index) =>
                                    <tr key={index}>
                                        <td className="hidden">{job.id}</td>
                                        <td className="table__text--align">{job.scheduleDateFormatted}</td>
                                        <td className="table__text--align"> {job.type}</td>
                                        <td className="table__text--align textaligncenter"> {job.quantityScheduled}</td>
                                        <td className="table__text--align"> {job.allocatedTo}</td>
                                        <td className="table__text--align textaligncenter">
                                            <input type='checkbox' checked={job.complete} disabled={true} />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={hideModal}>Close</button>
                </Modal.Footer>
            </Modal>
        </div>
    );

    let contents =
        loading || !props.showModal ? ""
            : renderDetails;

    return (<div>
        {contents}
    </div>)
}

export default AllocateAssociatedJobsData;